// using singleton pattern here
let instance = null;

class Breakpoints {
  constructor() {
    if (!instance) {
      instance = this;
    }
    this.cssQuery = '';

    this.checkCSSProperty();

    return instance;
  }

  checkCSSProperty() {
    this.cssQuery = window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/['"]+/g, '');
  }

  isSm() {
    return this.cssQuery === 'sm';
  }

  isMd() {
    return this.cssQuery === 'md';
  }

  isLg() {
    return this.cssQuery === 'lg';
  }

  isXl() {
    return this.cssQuery === 'xl';
  }
}

export function isSm() {
  const breakpoints = new Breakpoints();
  return breakpoints.isSm();
}

export function isMd() {
  const breakpoints = new Breakpoints();
  return breakpoints.isMd();
}

export function isLg() {
  const breakpoints = new Breakpoints();
  return breakpoints.isLg();
}

export function isXl() {
  const breakpoints = new Breakpoints();
  return breakpoints.isXl();
}

export function getBreakpoint() {
  const breakpoints = new Breakpoints();
  breakpoints.checkCSSProperty();
  return breakpoints.cssQuery;
}

export default Breakpoints;



// WEBPACK FOOTER //
// ./frontend/js/Base/Breakpoints.jsx